var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.questUrl
    ? _c(
        "div",
        { staticClass: "quest__quest-container" },
        [
          _c("vue-friendly-iframe", {
            attrs: { src: _vm.questUrl },
            on: { load: _vm.onFrameLoad }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }